import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

@Injectable({
  providedIn: 'root',
  useFactory: () => {
    return new ToastService();
  }
})
export class ToastService {
  private static instance: ToastService;
  private toasts = new BehaviorSubject<Toast[]>([]);
  toasts$ = this.toasts.asObservable();
  private idCounter = 0;

  constructor() {
    if (ToastService.instance) {
      return ToastService.instance;
    }
    ToastService.instance = this;
  }

  showToast(message: string, type: 'success' | 'error' | 'info' | 'warning') {
    const newToast: Toast = { id: this.idCounter++, message, type };
    this.toasts.next([...this.toasts.value, newToast]);
    setTimeout(() => this.dismissToast(newToast.id), 3000);
  }

  dismissToast(id: number) {
    this.toasts.next(this.toasts.value.filter((toast) => toast.id !== id));
  }
}
